module.exports = __webpack_public_path__ + "img/141d6a90b3bcb4a1da2375146ffc4de6.png";